<div
  class="webinar-card"
  [ngClass]="orientation"
  [routerLink]="['/webinars', item.id]"
  [class.past-webinar]="!item.isUpcoming"
  [class.disabled]="disabled"
  [class.inactive]="!item.active">
  <div
    class="webinar-card__image"
    [class.default]="!item.mediaImage"
    [ngStyle]="!item.mediaImage && { backgroundImage: { startDate: item.date } | offlineActivityImage }"
    [cropImage]="item.mediaImage | preSignedUrl | async"
    [crop]="item.mediaImage?.crop"
    [additionalOptions]="{ aspect_ratio: '16:9' }">

    <div class="webinar-top-indicators">
      @if (userAttendee) {
        <span class="webinar-status">
          <lib-icon icon="check" size="16"></lib-icon>
          {{ (item.isUpcoming ? 'WEBINARS.attending' : 'WEBINARS.attended') | translate }}
        </span>
      }

      @if (!item.active) {
        <div class="hidden-indicator" [matTooltip]="'COMMON.hidden' | translate">
          <lib-icon icon="eye-slash" size="18"></lib-icon>
        </div>
      }
    </div>

    @if (item?.users?.length) {
      <div class="webinar-users">
        @for (user of item.users | slice : 0 : 3; track user) {
          <div class="webinar-user" [class.opened]="item.users?.length === 1">
            <lib-user-avatar [user]="user" [size]="32"></lib-user-avatar>
            <span class="webinar-user-name">
              {{ user.formattedProfileName }}
            </span>
          </div>
        }
      </div>
    }
  </div>

  <div class="webinar-card__info">
    <span class="webinar-card-label">
      {{ item | eventLabel | translate }}
    </span>

    <div class="webinar-card-title">{{ item?.title }}</div>

    <span class="webinar-date-duration">
      <app-date-label-chip [date]="item.date | dateWithoutTimezone" [timezone]="item.timezone"></app-date-label-chip>

      @if (item.duration) {
        <span class="webinar-duration">
          <lib-icon icon="clock" [size]="16"></lib-icon>
          <span>{{ item.date | dateWithoutTimezone | customDate: 'HH:mm' }}</span>
          <span>({{ item.timezone | timezoneAbbreviation }}),</span>
          <span>{{ item.duration | minutesToTime : 'long' }}</span>
        </span>
      }
    </span>
  </div>

</div>
